import simpleParallax from 'simple-parallax-js';

$(window).on('load', function () {
  var image = document.getElementsByClassName('js-parallax');
  if ($(window).width() > 768) {
    new simpleParallax(image);
  }
});
